var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 57.6,
    viewBox: "0 0 74 57.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(-230 -1427)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(260 1427)",
    fill: "#f01544",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-truck",
    "data-name": "Icon awesome-truck",
    d: "M57.525,32.45H56.05V22.485a4.425,4.425,0,0,0-1.3-3.125l-9.21-9.21a4.425,4.425,0,0,0-3.125-1.3H38.35V4.425A4.426,4.426,0,0,0,33.925,0H4.425A4.426,4.426,0,0,0,0,4.425v29.5A4.426,4.426,0,0,0,4.425,38.35H5.9a8.85,8.85,0,1,0,17.7,0H35.4a8.85,8.85,0,1,0,17.7,0h4.425A1.479,1.479,0,0,0,59,36.875v-2.95A1.479,1.479,0,0,0,57.525,32.45ZM14.75,42.775a4.425,4.425,0,1,1,4.425-4.425A4.426,4.426,0,0,1,14.75,42.775Zm29.5,0a4.425,4.425,0,1,1,4.425-4.425A4.426,4.426,0,0,1,44.25,42.775ZM51.625,23.6H38.35V13.275h4.065l9.21,9.21Z",
    transform: "translate(230 1437.4)",
    fill: "#f01544"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.e9be89b9dd72c2e9240735cacfad3a27.svg";
export { ForwardRef as ReactComponent };